<div class="no-data-section">
  <div class="no-data">
    <img width="420" src="/assets/images/no-data-found.svg" />
  </div>
  <div class="no-data-text">No Data Found</div>
</div>
